import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 5.22136C10.4581 4.70235 11.1283 4.375 11.875 4.375C13.2557 4.375 14.375 5.49429 14.375 6.875C14.375 8.25571 13.2557 9.375 11.875 9.375C11.1283 9.375 10.4581 9.04765 10 8.52864M11.875 15.625H4.375V15C4.375 12.9289 6.05393 11.25 8.125 11.25C10.1961 11.25 11.875 12.9289 11.875 15V15.625ZM11.875 15.625H15.625V15C15.625 12.9289 13.9461 11.25 11.875 11.25C11.192 11.25 10.5516 11.4326 10 11.7517M10.625 6.875C10.625 8.25571 9.50571 9.375 8.125 9.375C6.74429 9.375 5.625 8.25571 5.625 6.875C5.625 5.49429 6.74429 4.375 8.125 4.375C9.50571 4.375 10.625 5.49429 10.625 6.875Z",
  stroke: "white",
  "stroke-width": "0.9375",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)

interface Props {
    backgroundFill?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlueUsersIcon',
  props: {
    backgroundFill: { default: "#2563EB" }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("rect", {
      width: "20",
      height: "20",
      rx: "5",
      fill: _ctx.backgroundFill
    }, null, 8, _hoisted_2),
    _hoisted_3
  ]))
}
}

})